import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import ReservationModal from "./ReservationModal";
import EditModal from "./EditModal";
import { isMobile } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import "./css/index.css";

export default function Parking1() {
  const [userStatus, setUserStatus] = useState();
  const [placesFromDB, setPlacesFromDB] = useState({});
  const [placesFromDB2, setPlacesFromDB2] = useState({});
  const [placesFromDB3, setPlacesFromDB3] = useState({});
  const [place, setPlace] = useState();
  const [placeData, setPlaceData] = useState();
  const [change, setChange] = useState(false);
  const [changeType, setChangeType] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [parking, setParking] = useState(true);
  const [section, setSection] = useState();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserStatus(user.displayName);
      }
    });
  }, []);

  // Funkcja do pobierania danych z Firebase
  const getPlaces = async () => {
    const docRef = doc(db, "parking1", "B4SJMr6WU7oc8qr4SssF");
    const response = await getDoc(docRef);

    if (response.exists()) {
      const parking1 = response.data().parking;
      const placesObj = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1A") {
            placesObj[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
              section: takenSeat.section,
            };
          }
        });
      }

      const placesObj2 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1B") {
            placesObj2[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
              section: takenSeat.section,
            };
          }
        });
      }

      const placesObj3 = {};
      if (parking1) {
        parking1.forEach((takenSeat) => {
          if (takenSeat.parking === "1C") {
            placesObj3[takenSeat.place] = {
              date: takenSeat.date,
              containerNumber: takenSeat.containerNumber,
              type: takenSeat.type,
              uid: takenSeat.uid,
              parking: takenSeat.parking,
              place: takenSeat.place,
              section: takenSeat.section,
            };
          }
        });
      }

      setPlacesFromDB(placesObj);
      setPlacesFromDB2(placesObj2);
      setPlacesFromDB3(placesObj3);
    }
  };

  useEffect(() => {
    getPlaces(); // Pobierz miejsca na początku
  }, [change]);

  const renderPlace1 = (placeId, section) => {
    const placeData = placesFromDB[placeId];
    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1A");
            setPlace(placeId);
            setOpen(true);
            setSection(section);
          }
        }}
        className={`parking-space-3 ${
          placeData &&
          placeData.section === section &&
          placeData.type === "Amazon"
            ? "amazon-place"
            : placeData &&
              placeData.section === section &&
              placeData.type === "Slam"
            ? "slam-place"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && placeData.section === section && (
            <p>{placeData.containerNumber}</p>
          )}
        </div>
      </div>
    );

    return parkingSpace;
  };

  const renderPlace2 = (placeId, section) => {
    const placeData = placesFromDB2[placeId];

    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1B");
            setPlace(placeId);
            setOpen(true);
            setSection(section);
          }
        }}
        className={`parking-space-3 ${
          placeData &&
          placeData.section === section &&
          placeData.type === "Amazon"
            ? "amazon-place"
            : placeData &&
              placeData.section === section &&
              placeData.type === "Slam"
            ? "slam-place"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && placeData.section === section && (
            <p>{placeData.containerNumber}</p>
          )}
        </div>
      </div>
    );

    return parkingSpace;
  };

  const renderPlace3 = (placeId, section) => {
    const placeData = placesFromDB3[placeId];

    const parkingSpace = (
      <div
        onClick={(e) => {
          if (placeData) {
            setChangeType(!changeType);
            setPlaceData(placeData);
            setOpen2(true);
          } else {
            setChangeType(!changeType);
            setParking("1C");
            setPlace(placeId);
            setOpen(true);
            setSection(section);
          }
        }}
        className={`parking-space-3 ${
          placeData &&
          placeData.section === section &&
          placeData.type === "Amazon"
            ? "amazon-place"
            : placeData &&
              placeData.section === section &&
              placeData.type === "Slam"
            ? "slam-place"
            : ""
        }`}
      >
        <div className="parking-space-3">
          {placeData && placeData.section === section && (
            <p>{placeData.containerNumber}</p>
          )}
        </div>
      </div>
    );

    return parkingSpace;
  };

  const btn_1 = document.querySelector(".btn-12");
  const btn_2 = document.querySelector(".btn-22");

  useEffect(() => {
    if (parking && btn_1 && btn_2) {
      btn_1.classList.add("btn-active");
      btn_2.classList.remove("btn-active");
    } else if (!parking && btn_1 && btn_2) {
      btn_2.classList.add("btn-active");
      btn_1.classList.remove("btn-active");
    }
  }, [parking, btn_1, btn_2]);

  //13
  const elements11 = Array.from({ length: 39 }, (_, index) => (
    <div key={index} className="item">
      {renderPlace1(index, 11)} <div className="circle-down"></div>
    </div>
  ));

  //12
  const elements12 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 || index === 25 || index === 38 ? "hidden" : "item"
      }
    >
      {renderPlace1(index, 12)} <div className="circle-up"></div>
    </div>
  ));

  //11
  const elements13 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37
          ? "hidden"
          : "item"
      }
    >
      {renderPlace1(index, 13)} <div className="circle-up"></div>
    </div>
  ));

  //10
  const elements14 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36
          ? "hidden"
          : "item"
      }
    >
      {renderPlace1(index, 14)} <div className="circle-up"></div>
    </div>
  ));

  //9
  const elements21 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35
          ? "hidden"
          : "item"
      }
    >
      {renderPlace2(index, 21)} <div className="circle-up"></div>
    </div>
  ));

  //8
  const elements22 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34
          ? "hidden"
          : "item"
      }
    >
      {renderPlace2(index, 22)} <div className="circle-up"></div>
    </div>
  ));

  //7
  const elements23 = Array.from({ length: 26 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 7 ||
        index === 20
          ? "hidden"
          : "item"
      }
    >
      {renderPlace2(index, 23)} <div className="circle-up"></div>
    </div>
  ));

  //6
  const elements24 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32
          ? "hidden"
          : "item"
      }
    >
      {renderPlace2(index, 24)} <div className="circle-up"></div>
    </div>
  ));

  //5
  const elements31 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32 ||
        index === 5 ||
        index === 18 ||
        index === 31
          ? "hidden"
          : "item"
      }
    >
      {renderPlace3(index, 31)} <div className="circle-down"></div>
    </div>
  ));

  //4
  const elements32 = Array.from({ length: 26 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32 ||
        index === 5 ||
        index === 18 ||
        index === 31 ||
        index === 4 ||
        index === 17 ||
        index === 30
          ? "hidden"
          : "item"
      }
    >
      {renderPlace3(index, 32)} <div className="circle-down"></div>
    </div>
  ));

  //3
  const elements33 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32 ||
        index === 5 ||
        index === 18 ||
        index === 31 ||
        index === 4 ||
        index === 17 ||
        index === 30 ||
        index === 3 ||
        index === 16 ||
        index === 29
          ? "hidden"
          : "item"
      }
    >
      {renderPlace3(index, 33)} <div className="circle-down"></div>
    </div>
  ));

  //2
  const elements34 = Array.from({ length: 39 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32 ||
        index === 5 ||
        index === 18 ||
        index === 31 ||
        index === 4 ||
        index === 17 ||
        index === 30 ||
        index === 3 ||
        index === 16 ||
        index === 29 ||
        index === 2 ||
        index === 15 ||
        index === 28
          ? "hidden"
          : "item"
      }
    >
      {renderPlace3(index, 34)} <div className="circle-down"></div>
    </div>
  ));

  //1
  const elements35 = Array.from({ length: 13 }, (_, index) => (
    <div
      key={index}
      className={
        index === 12 ||
        index === 25 ||
        index === 38 ||
        index === 11 ||
        index === 24 ||
        index === 37 ||
        index === 10 ||
        index === 23 ||
        index === 36 ||
        index === 9 ||
        index === 22 ||
        index === 35 ||
        index === 8 ||
        index === 21 ||
        index === 34 ||
        index === 7 ||
        index === 20 ||
        index === 33 ||
        index === 6 ||
        index === 19 ||
        index === 32 ||
        index === 5 ||
        index === 18 ||
        index === 31 ||
        index === 4 ||
        index === 17 ||
        index === 30 ||
        index === 3 ||
        index === 16 ||
        index === 29 ||
        index === 2 ||
        index === 15 ||
        index === 28 ||
        index === 1
          ? "hidden"
          : "item"
      }
    >
      {renderPlace3(index, 35)} <div className="circle-down"></div>
    </div>
  ));

  // Sekcje podzielone na 74, 73, i 73 elementy
  const section11 = elements11;
  const section12 = elements12;
  const section13 = elements13;
  const section14 = elements14;
  const section21 = elements21;
  const section22 = elements22;
  const section23 = elements23;
  const section24 = elements24;
  const section31 = elements31;
  const section32 = elements32;
  const section33 = elements33;
  const section34 = elements34;
  const section35 = elements35;

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossorigin="anonymous"
      ></link>
      <ReservationModal
        setChange={setChange}
        change={change}
        parking={parking}
        open={open}
        setOpen={setOpen}
        changeType={changeType}
        place={place}
        collection={"parking1"}
        documentId={"B4SJMr6WU7oc8qr4SssF"}
        section={section}
      />

      <EditModal
        setChange={setChange}
        change={change}
        open={open2}
        setChangeType={setChangeType}
        changeType={changeType}
        setOpen={setOpen2}
        placeData={placeData}
        collection={"parking1"}
        documentId={"B4SJMr6WU7oc8qr4SssF"}
      />
      <div
        className="content"
        style={{ display: "flex", flexDirection: "column", position: 'relative' }}
      >
        <div className="container" style={{ alignItems: 'center' }}>

          <div className="fence">
          <div className="road"><p>ROAD</p></div>

          <div className="wall"></div>
          <div className="access-2"><p>ACCESS</p></div>
          <div className="access-3"><p>ACCESS</p></div>
            <h3 style={{ textAlign: "center", marginBottom: '1rem' }}>PARKING 1A</h3>
            <div className="section-11">{section11}</div>
            <h3 style={{ textAlign: "center", marginTop: '5rem', marginBottom: '5rem' }}>PARKING 1B</h3>
            <div className="section-11">{section12}</div>
            <div className="section-22">{section13}</div>
            <div className="section-22">{section14}</div>
            <div className="section-22">{section21}</div>
            <div className="section-22">{section22}</div>
            <div className="section-22">{section23}</div>
            <div className="section-22">{section24}</div>
            <h3 style={{ textAlign: "center", marginBottom: '1rem', marginTop: '1rem' }}>PARKING 1C</h3>
            <div className="section-33">{section31}</div>
            <div className="section-33">{section32}</div>
            <div className="section-33">{section33}</div>
            <div className="section-33">{section34}</div>
            <div className="section-33">{section35}</div>
            <div className="access"><p>ACCESS</p></div>
          </div>
        </div>
      </div>
    </>
  );
}
